import React from "react";
import { seedSeparators } from "src/common/attrView/viewFormItems/Separator";
import { onError } from "src/common/onError";
import { AttrTypeName } from "src/types/AttrType";
import { ZAttribute } from "src/types/ZAttribute";
import { findNodeByKey } from "src/common/findNodeByKey";
import { ZUid } from "src/types/zUid";
import { makeLabels4Leaves } from "../../makeLabels4Leaves";
import { zAttrLabelMeta } from "../../types/ZAttrLabelMeta";
import { ZAttrLabelTreeData } from "../../types/ZAttrLabelTreeData";

export const getEntityLabel = (
  entityId: ZUid,
  attrTreeData: ZAttrLabelTreeData,
  attributeList: ZAttribute[],
  typesMap: Record<string, string>,
  labelAttrs: ZUid[],
  renderSeparator?: (separator: React.ReactNode) => React.ReactNode,
) => {
  try {
    if (!attrTreeData) {
      throw Error("system error");
    }
    const meta = zAttrLabelMeta.parse(attrTreeData.attrLabelMeta);
    if (
      !(
        meta.type === AttrTypeName.object ||
        meta.type === AttrTypeName.childEntities
      )
    ) {
      throw Error("system error");
    }
    const keys = meta.links[entityId]?.filter(Boolean) as string[];
    if (!keys) {
      throw Error("system error");
    }
    const nodesAtts = keys
      .map((key) => findNodeByKey(key, [attrTreeData]))
      .filter(Boolean) as ZAttrLabelTreeData[];

    const sorted = labelAttrs
      .map((id) => nodesAtts.find((n) => String(n.attrId) === id))
      .filter(Boolean) as ZAttrLabelTreeData[];

    const entityLabel = makeLabels4Leaves(sorted, attributeList, typesMap);
    return seedSeparators(
      entityLabel.map((l, i) => ({ content: l, key: i })),
      "comma",
      renderSeparator,
    );
  } catch (error) {
    onError(error);
    return "";
  }
};
